module.exports = ".oblique {\n  font-style: oblique;\n}\n"